import {Subscription} from 'rxjs';

import IPlayer from '../../../Player/Interfaces/IPlayer';

import createTimelineInspectStream    from './Streams/createTimelineInspectStream';
import createTimelineScrubStream      from './Streams/createTimelineScrubStream';
import createTimelineTapStream        from './Streams/createTimelineTapStream';
import subscribeToPlaybackStoreUpdate from './Subscribers/subscribeToPlaybackStoreUpdate';
import subscribeToTimelineInspect     from './Subscribers/subscribeToTimelineInspect';
import subscribeToTimelineScrub       from './Subscribers/subscribeToTimelineScrub';
import subscribeToTimelineTap         from './Subscribers/subscribeToTimelineTap';

const connectTimelineSubscriptions = (
    player: IPlayer
): Subscription[] => {
    const {uiEvents$} = player.ui;
    const {playback, timeline} = player.state.stores;

    return [
        subscribeToPlaybackStoreUpdate(playback.update$, timeline),
        subscribeToTimelineInspect(createTimelineInspectStream(uiEvents$), timeline),
        subscribeToTimelineScrub(createTimelineScrubStream(uiEvents$), timeline),
        subscribeToTimelineTap(createTimelineTapStream(uiEvents$), timeline)
    ];
};

export default connectTimelineSubscriptions;